import { IGameSession, IGame, IGameProvider, ILobbySection, IGameActivity, IGameCategory } from '@libs/interfaces';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { GAME_SCREEN_LAYOUT, GAME_TYPE, IGameState, IGrigGameSession, SCREEN_GRID_TYPE } from './model';

export const selectSessionFeat = createFeatureSelector<Readonly<IGameState>>('games');

export const selectGame = createSelector(
  selectSessionFeat,
  (session: IGameState): Partial<IGame> =>
    session.grid_game_sessions ? session.grid_game_sessions[session.selectedIndex]?.game : null,
);
export const selectGameSession = createSelector(
  selectSessionFeat,
  (session: IGameState): Partial<IGameSession> =>
    session.grid_game_sessions ? session.grid_game_sessions[session.selectedIndex]?.session : null,
);
export const selectGameType = createSelector(selectSessionFeat, (session: IGameState): GAME_TYPE => session.game_type);
export const selectGamesCategories = createSelector(
  selectSessionFeat,
  (session: IGameState): ILobbySection[] => session.categories,
);
export const selectEnabledGamesProviders = createSelector(selectSessionFeat, (session: IGameState): IGameProvider[] =>
  session.gamesProviders.filter(provider => provider.enabled),
);
export const selectAllGamesProviders = createSelector(
  selectSessionFeat,
  (session: IGameState): IGameProvider[] => session.gamesProviders,
);
export const selectSearcherGamesCategories = createSelector(
  selectSessionFeat,
  (session: IGameState): IGame[] => session.categorySearchGames,
);
export const selectFullscreen = createSelector(selectSessionFeat, (session: IGameState): boolean => session.fullscreen);
export const selectGAmeActivity = createSelector(
  selectSessionFeat,
  (session: IGameState): IGameActivity[] => session.activity,
);
export const selectGameScreenLayout = createSelector(
  selectSessionFeat,
  (session: IGameState): GAME_SCREEN_LAYOUT => session.game_screen_layout,
);
export const selectGridGameSession = createSelector(
  selectSessionFeat,
  (session: IGameState): IGrigGameSession =>
    session.grid_game_sessions ? session.grid_game_sessions[session.selectedIndex] : null,
);
export const selectGridGameSessions = createSelector(
  selectSessionFeat,
  (session: IGameState): IGrigGameSession[] => session?.grid_game_sessions,
);
export const selectSelectedIndex = createSelector(
  selectSessionFeat,
  (session: IGameState): number => session.selectedIndex,
);
export const selectDesktop = createSelector(
  selectSessionFeat,
  (session: IGameState): SCREEN_GRID_TYPE => session.desktop,
);
export const selectShowGamesTree = createSelector(
  selectSessionFeat,
  (session: IGameState): boolean => session.showGamesTree,
);
export const selectGameOffice = createSelector(selectSessionFeat, (session: IGameState): IGame => session.game);
